import { Overlay } from "ol";
import { useContext, useEffect, useRef, useState } from "react";
import MapContext from "../Map/MapContext";

const TimelineSpeedOverlay = ({ position, averageSpeedKmh, pingCount }) => {
  const [overlay, setOverlay] = useState(null);
  const overlayRef = useRef();
  const { map } = useContext(MapContext);

  useEffect(() => {
    const ov = new Overlay({
      element: overlayRef.current,
      positioning: "top-center",
      stopEvent: false,
      offset: [0, 16],
    });

    setOverlay(ov);
  }, []);

  useEffect(() => {
    if (!overlay || !position) return;
    overlay.setPosition(position);
  }, [overlay, position]);

  useEffect(() => {
    if (!map || !overlay) return;
    map.addOverlay(overlay);

    return () => {
      map.removeOverlay(overlay);
    };
  }, [overlay, map]);

  const visible = Boolean(position) && averageSpeedKmh !== null && averageSpeedKmh !== undefined;

  return (
    <div
      className="timeline-speed-badge"
      ref={overlayRef}
      style={{ display: visible ? "block" : "none" }}
    >
      {visible && (
        <>
          <div className="timeline-speed-badge-value">
            Avg speed: {(averageSpeedKmh / 1.609).toFixed(0)} mph
          </div>
          <div className="timeline-speed-badge-count">
            {pingCount} ping{pingCount === 1 ? "" : "s"}
          </div>
        </>
      )}
    </div>
  );
};

export default TimelineSpeedOverlay;
